/**
 * SVG country flag from the flag-icons sprite set (loaded per flag by the browser on demand).
 * Windows has no flag emoji, so this is the only cross-platform option. The ISO code stays as
 * screen-reader text only.
 */
export function Flag({ code, className = '' }: { code: string; className?: string }) {
  const iso = code.toLowerCase();
  return (
    <span className={['inline-flex items-center', className].join(' ')}>
      <span aria-hidden className={`fi fi-${iso} text-[1.15em]`} />
      <span className="sr-only">{code.toUpperCase()}</span>
    </span>
  );
}
